/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Somethingwrong2Inputs */

const id_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terjadi kesalahan. Silakan coba lagi.`)
};

const ms_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesuatu tidak kena. Sila cuba lagi.`)
};

const da_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noget gik galt. Prøv venligst igen.`)
};

const de_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.`)
};

const en_us2_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

const es_es2_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal. Por favor, inténtalo de nuevo.`)
};

const es_mx2_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal. Por favor, inténtalo de nuevo.`)
};

const fil_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May maling nangyari. Pakisubukan muli.`)
};

const fr_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite. Veuillez réessayer.`)
};

const it_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualcosa è andato storto. Riprova.`)
};

const hu_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valami hiba történt. Kérjük, próbáld újra.`)
};

const nl_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is iets misgegaan. Probeer het opnieuw.`)
};

const no_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noe gikk galt. Prøv igjen.`)
};

const pl_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coś poszło nie tak. Spróbuj ponownie.`)
};

const pt_br2_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

const pt_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo correu mal. Tente novamente.`)
};

const ro_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceva nu a mers bine. Încearcă din nou.`)
};

const fi_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokin meni pieleen. Yritä uudelleen.`)
};

const sv_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Något gick fel. Försök igen.`)
};

const vi_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xảy ra lỗi. Vui lòng thử lại.`)
};

const tr_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir şeyler ters gitti. Lütfen tekrar deneyin.`)
};

const cs_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Něco se pokazilo. Zkuste to prosím znovu.`)
};

const bg_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нещо се обърка. Моля, опитайте отново.`)
};

const ru_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что-то пошло не так. Пожалуйста, попробуйте снова.`)
};

const uk_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щось пішло не так. Спробуйте ще раз.`)
};

const ar_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدث خطأ ما. حاول مرة أخرى.`)
};

const hi_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुछ गलत हुआ।`)
};

const th_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดข้อผิดพลาด กรุณาลองอีกครั้ง`)
};

const ja_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラーが発生しました。もう一度お試しください。`)
};

const zh_cn2_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

const zh_hant1_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

const ko_forms_androidbeta_somethingwrong2 = /** @type {(inputs: Forms_Androidbeta_Somethingwrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong. Please try again.`)
};

/**
* | output |
* | --- |
* | "Something went wrong. Please try again." |
*
* @param {Forms_Androidbeta_Somethingwrong2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_somethingwrong2 = /** @type {((inputs?: Forms_Androidbeta_Somethingwrong2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Somethingwrong2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "ms") return ms_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "da") return da_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "de") return de_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "fil") return fil_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "fr") return fr_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "it") return it_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "hu") return hu_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "nl") return nl_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "no") return no_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "pl") return pl_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "pt") return pt_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "ro") return ro_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "fi") return fi_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "sv") return sv_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "vi") return vi_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "tr") return tr_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "cs") return cs_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "bg") return bg_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "ru") return ru_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "uk") return uk_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "ar") return ar_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "hi") return hi_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "th") return th_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "ja") return ja_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_somethingwrong2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_somethingwrong2(inputs)
	return ko_forms_androidbeta_somethingwrong2(inputs)
});
export { forms_androidbeta_somethingwrong2 as "forms.androidBeta.somethingWrong" }